"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.02 5H6C3.79 5 2 6.79 2 9c0 .55.12 1.07.32 1.54.57-2.25 1.9-4.19 3.7-5.54zm9.08-1.5C14.36 2.59 13.25 2 12 2s-2.36.59-3.1 1.5c.98-.32 2.02-.5 3.1-.5s2.12.18 3.1.5zM12 5.31c0 2.24 1.82 4.06 4.06 4.06.93 0 1.82-.32 2.53-.89-1.43-2.09-3.84-3.47-6.56-3.48-.01.11-.03.21-.03.31zM2.5 16.12c-.31.56-.5 1.19-.5 1.88 0 2.21 1.79 4 4 4 .44 0 .85-.07 1.25-.2-2.23-1.21-3.94-3.24-4.75-5.68zm19.18-5.58c.2-.47.32-.99.32-1.54 0-2.21-1.79-4-4-4h-.02c1.8 1.35 3.13 3.29 3.7 5.54zM16.75 21.8c.4.13.81.2 1.25.2 2.21 0 4-1.79 4-4 0-.69-.19-1.32-.5-1.88-.81 2.44-2.52 4.47-4.75 5.68z",
  opacity: ".3"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M21.97 13.52v-.04C23.21 12.38 24 10.78 24 9c0-3.31-2.69-6-6-6-.26 0-.52.02-.78.06C16.19 1.23 14.24 0 12 0S7.81 1.23 6.78 3.06C6.52 3.02 6.26 3 6 3 2.69 3 0 5.69 0 9c0 1.78.79 3.38 2.02 4.48v.04C.79 14.62 0 16.22 0 18c0 3.31 2.69 6 6 6 1.39 0 2.67-.48 3.69-1.28.74.18 1.51.28 2.31.28s1.57-.1 2.31-.28c1.02.8 2.3 1.28 3.69 1.28 3.31 0 6-2.69 6-6 0-1.78-.79-3.38-2.03-4.48zM18 5c2.21 0 4 1.79 4 4 0 .55-.12 1.07-.32 1.54-.57-2.25-1.9-4.19-3.7-5.54H18zm.6 3.48c-.71.57-1.6.89-2.53.89C13.82 9.38 12 7.55 12 5.31c0-.1.02-.21.03-.31 2.72.01 5.13 1.39 6.57 3.48zM12 2c1.25 0 2.36.59 3.1 1.5-.98-.32-2.02-.5-3.1-.5s-2.12.18-3.1.5C9.64 2.59 10.75 2 12 2zM2 9c0-2.21 1.79-4 4-4h.02c-1.8 1.35-3.13 3.29-3.7 5.54C2.12 10.07 2 9.55 2 9zm4 13c-2.21 0-4-1.79-4-4 0-.69.19-1.32.5-1.88.8 2.44 2.52 4.47 4.74 5.68-.39.13-.8.2-1.24.2zm6-1c-4.41 0-8-3.59-8-8 0-3.72 2.56-6.85 6-7.74v.05c0 3.34 2.72 6.06 6.06 6.06 1.26 0 2.45-.39 3.45-1.09.31.86.49 1.77.49 2.72 0 4.41-3.59 8-8 8zm6 1c-.44 0-.85-.07-1.25-.2 2.23-1.21 3.94-3.24 4.74-5.68.31.56.5 1.2.5 1.88.01 2.21-1.78 4-3.99 4z"
}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "9",
  cy: "14",
  r: "1.25"
}, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "15",
  cy: "14",
  r: "1.25"
}, "3")], 'Face2TwoTone');

exports.default = _default;